<!-- Commented out for now 
  @if (tile.ikon) {
  <mat-icon [svgIcon]="tile.ikon"></mat-icon>
} -->
@if (tile.img.src || tile.img.src !== "") {
    <img class="tile-img" [src]="tile.img.src" [alt]="tile.img.alt" />
}
<div class="tile-content">
    <h2 class="mat-h1">{{ tile.titel }}</h2>
    @if (tile.tekst) {
        <p>{{ tile.tekst }}</p>
    }
    @if (tile.tekst2) {
        <p>{{ tile.tekst2 }}</p>
    }
</div>
